import angular, { ILocationService, IScope } from 'angular';

export default angular.module('directives.buttonLink', [])
  .directive('btnHref', ($location: ILocationService): ng.IDirective => {
    'ngInject';

    return {
      restrict: 'A',
      link: (scope: IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes): void => {
        let path: string;

        attrs.$observe('btnHref', (val) => {
          path = val as string;
        });

        element.bind('click', () => {
          scope.$apply(() => {
            $location.path(path);
          });
        });
      },
    };
  })
  .name;
